/*
 * Copyright (c) 2025-2026 Aegis AO Soft LLC and Alexander Orlov.
 * 34 Middletown Ave, Atlantic Highlands, NJ 07716
 *
 * THIS SOFTWARE IS THE CONFIDENTIAL AND PROPRIETARY INFORMATION OF
 * Aegis AO Soft LLC and Alexander Orlov.
 *
 * This code may be used, reproduced, modified, or distributed ONLY with the
 * prior written permission of Aegis AO Soft LLC / Alexander Orlov.
 *
 * Author: Alexander Orlov
 * Aegis AO Soft LLC
 */


import apiClient from './client';

export interface TollSystemConfiguration {
  systemName: string;
  paymentModel: string;
  platformMarkupShare: number;
  baseMarkupPercent: number;
  stripeFeePercent: number;
  stripeFeeFixed: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
}

export interface CreateTollSystemConfiguration {
  systemName: string;
  paymentModel: string;
  platformMarkupShare: number;
  baseMarkupPercent: number;
  stripeFeePercent: number;
  stripeFeeFixed: number;
  isActive: boolean;
}

const BASE = '/toll-configuration';

export const tollConfigurationApi = {
  getAll: async (): Promise<TollSystemConfiguration[]> => {
    const response = await apiClient.get(BASE);
    return response.data;
  },

  getByName: async (name: string): Promise<TollSystemConfiguration> => {
    const response = await apiClient.get(`${BASE}/${encodeURIComponent(name)}`);
    return response.data;
  },

  create: async (dto: CreateTollSystemConfiguration): Promise<TollSystemConfiguration> => {
    const response = await apiClient.post(BASE, dto);
    return response.data;
  },

  update: async (name: string, dto: CreateTollSystemConfiguration): Promise<TollSystemConfiguration> => {
    const response = await apiClient.put(`${BASE}/${encodeURIComponent(name)}`, dto);
    return response.data;
  },

};
